/**
 * ADGMQ
 * imedia
 *
 * Map
 */

(function($) {
  $(document).ready(function() {
    $('svg .map__territory-link').on('click', function() {
      window.location.href = $(
        '.map__territory-link-' + $(this).attr('data-territory') + ' a',
      ).attr('href');
    });

    $('.map__territory-link').hover(
      function() {
        $('.map__territory-link-' + $(this).attr('data-territory')).addClass(
          'hover',
        );
        $('.territory_' + $(this).attr('data-territory') + '_svg').attr(
          'fill',
          '#5579f2',
        );
      },
      function() {
        $('.map__territory-link-' + $(this).attr('data-territory')).removeClass(
          'hover',
        );
        $('.territory_' + $(this).attr('data-territory') + '_svg').attr(
          'fill',
          '#fff',
        );
      },
    );
  });
})(jQuery);
